import { tv } from "tailwind-variants";

import { sectionPaddings } from "@/common/constants";
import { monsterrat } from "@/services/styles/fonts";

export const getNewsletterSectionClass = tv({ base: [sectionPaddings, "pb-0 lg:pt-48 lg:pb-0"] });

const animationInUpClass =
  "group-[.animate-intersected-in]/intersected:animate-fade-in-up opacity-0 animate-fill-forwards!";

export const getHeadingClass = tv({
  base: [
    "font-semibold text-2xl lg:text-4xl",
    "animate-delay-300! animate-duration-500! lg:animate-duration-300!",
    monsterrat.className,
    animationInUpClass,
  ],
});

export const getPhotoClass = tv({
  base: [
    "-top-12 lg:-top-24 pointer-events-none relative max-h-[325px] select-none lg:max-h-none",
    "animate-delay-100! animate-duration-500! lg:animate-duration-300!",
    animationInUpClass,
  ],
});

export const getEmailFormClass = tv({
  base: [
    "mt-10 flex w-full max-w-2xl flex-col gap-7",
    "animate-delay-300! animate-duration-500! lg:animate-duration-300!",
    animationInUpClass,
  ],
});

export const getInputClass = tv({ base: "rounded-3xl border-black/20 bg-white pl-6" });

export const getInputLabelClass = tv({ base: "pl-4" });

export const getCtaWrapperClass = tv({
  base: ["-right-0.5 absolute top-px scale-y-[1.07]"],
});

export const getCtaClass = tv({
  base: "w-full px-5 lg:max-w-[250px]",
});
